module.exports = __webpack_public_path__ + "media/images/property-1e74c77d.jpg";